// Common header data for history log tables
const baseHeaderData = [
  {
    columnKey: "campaignName",
    header: "Name",
  },
  {
    columnKey: "campaignType",
    header: "Type",
  },
  {
    columnKey: "user",
    header: "User",
  },
  {
    columnKey: "updatedDate",
    header: "Updated Date",
  },
  {
    columnKey: "action",
    header: "Action",
  },
];

// Campaign-specific header data with additional campaignTitleShort column
const campaignHeaderData = [
  {
    columnKey: "campaignName",
    header: "Campaign Name",
  },
  {
    columnKey: "campaignTitleShort",
    header: "Campaign Short Name",
  },
  {
    columnKey: "campaignType",
    header: "Type",
  },
  {
    columnKey: "user",
    header: "User",
  },
  {
    columnKey: "updatedDate",
    header: "Updated Date",
  },
  {
    columnKey: "action",
    header: "Action",
  },
];

// Configuration-specific header data with Action Performed column after Type
const configurationHeaderData = [
  {
    columnKey: "campaignName",
    header: "Name",
  },
  {
    columnKey: "campaignType",
    header: "Type",
  },
  {
    columnKey: "actionPerformed",
    header: "Action Performed",
  },
  {
    columnKey: "user",
    header: "User",
  },
  {
    columnKey: "updatedDate",
    header: "Updated Date",
  },
  {
    columnKey: "action",
    header: "Action",
  },
];

// Function to get appropriate headers based on source
export const getHistoryLogHeaderData = (source) => {
  // Start with the base header data based on source
  let headers =
    source === "campaigns" ? [...campaignHeaderData] : [...baseHeaderData];

  if (source === "configuration") {
    return [...configurationHeaderData];
  }

  // Create a dynamic header array based on source
  if (source === "content") {
    // Always include Name, subType, entitySubType, User, Updated Date, and Action columns
    const dynamicHeaders = [
      {
        columnKey: "campaignName",
        header: "Name",
      },
      {
        columnKey: "subType",
        header: "Type",
      },
      {
        columnKey: "entitySubType",
        header: "Sub Type",
      },
      {
        columnKey: "user",
        header: "User",
      },
      {
        columnKey: "updatedDate",
        header: "Updated Date",
      },
      {
        columnKey: "action",
        header: "Action",
      },
    ];

    return dynamicHeaders;
  }

  return headers;
};

// For backward compatibility
export const historyLogHeaderData = baseHeaderData;
